import { Component, inject, ViewChild } from '@angular/core';
import { InputComponent } from "../../form/input/input.component";
import { DialogComponent } from "../dialog.component";
import { FormBuilder,ReactiveFormsModule, Validators } from "@angular/forms";
import { CustomEmailValidator } from "../../form/form-validators";
import { ButtonComponent } from "../../button/button.component";

@Component({
  selector: 'app-confirm-email-dialog',
  standalone: true,
  imports: [InputComponent, ReactiveFormsModule, DialogComponent, ButtonComponent],
  templateUrl: './confirm-email-dialog.component.html',
  styleUrls: ['./confirm-email-dialog.component.scss'],
})
export class ConfirmEmailDialogComponent {
  @ViewChild(DialogComponent) dialog!: DialogComponent;

  private fb = inject(FormBuilder);

  form = this.fb.group({
    email: ['', [Validators.required, CustomEmailValidator()]],
  });

  onAdd() {
    this.dialog.close(this.form.controls['email'].value);
  }
}
